import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 20,
	viewBox: "0 0 19 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.52678 12.3767C8.19345 11.9613 7.59441 11.8791 7.15963 12.1883L6.00987 12.8743C5.91325 12.9468 5.78282 12.9661 5.66688 12.9274C5.55094 12.8888 5.45915 12.8018 5.4205 12.6859L4.64755 10.3671C4.60408 10.227 4.63789 10.0724 4.73934 9.97092L5.69103 9.02406V6.08203L0.56543 9.95643V17.5651C0.56543 19.0167 0.56543 18.9247 0.56543 19.9999H4.52678V18.396C4.52678 18.3042 4.5606 18.2125 4.61857 18.14L8.49779 13.6666C8.81664 13.2994 8.8263 12.7584 8.52678 12.3767Z",
		fill: "#FF3131"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.45947 0V4.42995V9.47826V11.6232L6.65271 11.4831C6.97638 11.256 7.34836 11.1353 7.73967 11.1353C8.30971 11.1353 8.84595 11.3913 9.20343 11.8357L9.20826 11.8406C9.76865 12.5459 9.74933 13.5556 9.15995 14.2367L6.45947 17.3478V19.6135H18.8266V0H6.45947ZM9.19122 5.54106H8.45209V1.44927H9.19122V5.54106ZM12.643 11.8357C11.387 11.8357 10.3725 10.8213 10.3725 9.56521C10.3725 8.30918 11.387 7.29468 12.643 7.29468C13.8991 7.29468 14.9136 8.30918 14.9136 9.56521C14.9136 10.8213 13.8991 11.8357 12.643 11.8357ZM16.834 18.1642H16.0949V14.5555H16.834V18.1642Z",
		fill: "#85A0AD"
	})]
});
export default SvgSend;
